import classNames from 'classnames';
import Image from 'next/image';

import { SliderWrapper, SectionTitle } from '@/ui/index';

import styles from './ServiceSlider.module.scss';

const ServiceSlider = ({ data, className }) => {
  const renderSlide = (item, key) => {
    return (
      <Image
        src={item?.image}
        alt='icon'
        title='icon'
        key={key}
        loading='lazy'
        layout='fill'
        itemScope
        itemType='https://schema.org/ImageObject'
      />
    );
  };

  const options = {
    slidesToShow: 1,
    infinite: true,
  };

  return (
    <section
      className={classNames(styles['service-slider'], className)}
      itemScope
      itemType='https://schema.org/ImageGallery'
    >
      {data?.title && (
        <SectionTitle
          titleModify={classNames([
            styles['service-slider__title'],
            'title--medium',
          ])}
        >
          {data?.title}
        </SectionTitle>
      )}
      <SliderWrapper arrows options={options}>
        {data?.images?.map(renderSlide)}
      </SliderWrapper>
    </section>
  );
};

export default ServiceSlider;
